import React from "react";
import { ERROR_RECOVERY_CONFIG } from "../config";
import { toast } from "react-toastify";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error,
    };
  }

  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);

    const {
      redirectOnError,
      redirectPath,
      showToast,
      toastMessage,
      preventLoop,
    } = ERROR_RECOVERY_CONFIG;

    const currentPath = window.location.pathname;
    const isSamePage = currentPath === redirectPath;
    const alreadyRecovered = sessionStorage.getItem("error_recovered");

    let shouldRedirect = redirectOnError;

    
    if (preventLoop && alreadyRecovered) {
      console.warn("Error already recovered once, preventing loop");
      shouldRedirect = false;
    }

    
    if (showToast && toastMessage) {
      toast.error(toastMessage, {
        autoClose: 2500,
      });
    }

    
    if (shouldRedirect && redirectPath && !isSamePage) {
      const delay = showToast ? 250 : 0;

      setTimeout(() => {
        sessionStorage.setItem("error_recovered", "true"); 
        window.location.replace(redirectPath);
      }, delay);
    }
  }

  render() {
    if (this.state.hasError) {
      const { redirectOnError } = ERROR_RECOVERY_CONFIG;

      return (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="text-center">
            <h4>Something went wrong</h4>

            {process.env.NODE_ENV === "development" && this.state.error && (
              <div style={{ marginTop: "10px", color: "red" }}>
                <strong>Error:</strong> {this.state.error.message}
              </div>
            )}

            {redirectOnError ? (
              <p>Recovering application...</p>
            ) : (
              <p>Please refresh the page</p>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;